import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { BackToSelection } from "./BackToSelection";

type BlogEventHeaderProps = {
  date: string;
};

export const BlogEventHeader = ({ date }: BlogEventHeaderProps) => {
  return (
    <div className="flex w-full flex-col justify-between gap-8 bg-secondary px-4 py-14 ph:flex-row ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <BackToSelection />
      <time className="text-primary/60">
        {format(new Date(date), "dd MMMM yyyy", {
          locale: fr,
        })}
      </time>
    </div>
  );
};
